<ion-content class="ion-no-padding">
  <form class="lead-form itinerary-model-container">
    <div class="itinerary-model-header">
      <ion-header class="ion-no-border ion-padding-horizontal sticky-top bg-white">
        <ion-toolbar class="header-first-toolbar">
          <ion-title class="text-start ion-no-padding title-blue"><span>{{ editUserId ? 'Edit User' : 'Add User'
              }}</span></ion-title>
          <ion-buttons slot="end" class="ion-no-margin">


            <!-- <ion-button class="filled-blue-btn">
              Save & Next
            </ion-button> -->
            <ion-button class="unfilled-gray-btn" (click)="closeModal()">
              <ion-icon name="close-outline"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
    </div>
    <div class="model-content">
      <div class="dashed-line"></div>
      <div class="d-flex py-1 flex-wrap ion-padding-horizontal nav-buttons-container">
        <ion-button class="unfilled-black-btn-sm" (click)="onViewChangeFromTab('userdetails')"
          [ngClass]="{'filled-black-btn-sm': componentView === 'userdetails', 'tab-green':userDetailsData?.dataSaved}">
          User Details
        </ion-button>


        <ion-button class="unfilled-black-btn-sm" (click)="onViewChangeFromTab('useraccess')"
          [ngClass]="{'filled-black-btn-sm': componentView === 'useraccess', 'tab-green':userAcessData?.dataSaved}"
          [disabled]="!userId">
          User Access
        </ion-button>
      </div>
    </div>
    <div [ngSwitch]="componentView" class="itinerary-model-content-main">
      <app-user-details *ngSwitchCase="'userdetails'" (viewChange)="onViewChnage($event)"
        (emitUserId)="assignUserId($event)" [userId]="userId" [editUserId]="editUserId"
        [addUserDetails]="userDetailsData" (emitAddUserdetails)="patchUserDetailsValues($event)"
        (submitUser)="onSubmit(true)"></app-user-details>
       
      <app-user-access *ngSwitchCase="'useraccess'" (viewChange)="onViewChnage($event)" [userId]="userId"
        [editUserId]="editUserId"  [storedFormData]="userAcessData" (storeFormData)="patchUserAccess($event)"
        (showReview)="showReview()" (submitUser)="onSubmit()"></app-user-access>
    </div>
  </form>
</ion-content>

